import { render } from "./PrepaidRechargeSuccessPage.vue?vue&type=template&id=14d9a270&ts=true"
import script from "./PrepaidRechargeSuccessPage.vue?vue&type=script&lang=ts"
export * from "./PrepaidRechargeSuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__